import { useEffect, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import "./install.css";
import logo from "./assets/bersihir-text.png";
import appIcon from "./assets/bersihir.png";

const DOWNLOAD_URL = "https://bersihir.github.io/bersihir-download/releases/android/android-release-v0.1.2.apk";

type Platform = "ios" | "android";

const NAV = [
  { id: "download", label: "Download" },
  { id: "howto", label: "Cara Pasang" },
  { id: "whatsnew", label: "Yang Baru" },
  { id: "screenshots", label: "Tangkapan" },
  { id: "versions", label: "Riwayat" },
];

const STEPS: Record<Platform, { n: string; title: string; desc: string }[]> = {
  ios: [
    { n: "1", title: "Buka di perangkatmu", desc: "Pindai kode QR dengan kamera ponsel, atau buka tautan ini langsung di iPhone/iPad." },
    { n: "2", title: "Ketuk Pasang", desc: "Konfirmasi permintaan untuk menambahkan BERSIHir ke layar utama. Ikon muncul saat aplikasi diunduh." },
    { n: "3", title: "Percayai pengembang", desc: "Buka Pengaturan › Umum › Manajemen VPN & Perangkat, pilih BERSIHir, lalu ketuk Percayai untuk membuka aplikasi." },
  ],
  android: [
    { n: "1", title: "Buka di perangkatmu", desc: "Pindai kode QR dengan kamera, atau buka tautan ini langsung di ponsel Android." },
    { n: "2", title: "Unduh berkas APK", desc: "Ketuk Pasang untuk mengunduh BERSIHir.apk. Izinkan peramban mengunduh berkas bila diminta." },
    { n: "3", title: "Izinkan & pasang", desc: 'Buka berkas APK, aktifkan "Izinkan dari sumber ini" di Pengaturan, lalu ketuk Pasang.' },
  ],
};

const CHANGELOG = [
  "Kelola pesanan layanan dari masuk hingga selesai dalam satu aplikasi.",
  "Manajemen pelanggan, staf, absensi, dan jadwal petugas.",
  "Kontrol inventaris, gudang, stok, dan pembukuan keuangan lengkap.",
  "Mode luring dengan sinkronisasi otomatis — tetap jalan tanpa internet.",
];

interface Version {
  ver: string;
  date: string;
  current?: boolean;
  badge?: string;
  feats: string[];
}

const VERSIONS: Version[] = [
  { ver: "v0.1.2", date: "30 Jun 2026", current: true, badge: "Rilis pertama", feats: [
    "Kelola pesanan layanan dari masuk hingga selesai",
    "Manajemen pelanggan, alamat, dan program loyalitas",
    "Atur staf, jadwal, dan absensi petugas",
    "Kontrol inventaris: gudang, stok, transfer & penerimaan barang",
    "Pembukuan lengkap: jurnal, buku besar & laporan keuangan",
    "Dashboard & laporan harian untuk pantau performa",
    "Mode luring (offline-first) dengan sinkronisasi otomatis",
  ] },
];

const SHOTS = ["Tangkapan 1", "Tangkapan 2", "Tangkapan 3", "Tangkapan 4"];

const InstallButton = () => (
  <a className="installbtn fx ac jc gap10" href={DOWNLOAD_URL} target="_blank" rel="noreferrer">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M12 3v12m0 0 4.5-4.5M12 15l-4.5-4.5M5 19h14" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" /></svg>
    Pasang BERSIHir
  </a>
);

function HowTo({ platform, setPlatform }: { platform: Platform; setPlatform: (p: Platform) => void }) {
  return (
    <section id="howto" className="scard">
      <div className="fx ac jb gap12" style={{ marginBottom: 10 }}>
        <div className="cardh fx ac gap10"><span className="gold">✦</span> Cara memasang</div>
        <div className="ptabs fx ac">
          <button className={`ptab ${platform === "ios" ? "on" : ""}`} onClick={() => setPlatform("ios")}>iOS</button>
          <button className={`ptab ${platform === "android" ? "on" : ""}`} onClick={() => setPlatform("android")}>Android</button>
        </div>
      </div>
      {STEPS[platform].map((s) => (
        <div className="step fx gap16" key={s.n}>
          <div className="stepn fx ac jc">{s.n}</div>
          <div className="col gap8"><div className="steptitle">{s.title}</div><div className="stepdesc">{s.desc}</div></div>
        </div>
      ))}
    </section>
  );
}

const WhatsNew = () => (
  <section id="whatsnew" className="scard">
    <div className="fx ac jb" style={{ marginBottom: 16 }}>
      <div className="cardh fx ac gap10"><span className="gold">✦</span> Yang baru</div>
      <span className="vpill">v0.1.2 · 30 Jun</span>
    </div>
    {CHANGELOG.map((line, i) => (
      <div className="clrow fx gap12" key={i}><div className="cldot" /><div className="cltext">{line}</div></div>
    ))}
  </section>
);

const Screenshots = () => (
  <section id="screenshots" className="scard shotcard">
    <div className="fx ac jb wrap gap12" style={{ marginBottom: 14 }}>
      <div className="cardh fx ac gap10"><span className="gold">✦</span> Tangkapan layar</div>
      <span className="muted fs13 fw7">Pratinjau build beta</span>
    </div>
    <div className="shots">
      {SHOTS.map((s) => (<div className="shot" style={{ width: 198, height: 418 }} key={s}>{s}</div>))}
    </div>
  </section>
);

const Versions = () => (
  <section id="versions" className="scard shotcard">
    <div className="fx ac jb wrap gap12" style={{ marginBottom: 22 }}>
      <div className="cardh fx ac gap10"><span className="gold">✦</span> Riwayat versi</div>
      <span className="muted fs13 fw7">Semua fitur BERSIHir di setiap rilis</span>
    </div>
    <div>
      {VERSIONS.map((v) => (
        <div className="vitem" key={v.ver}>
          <div className="vrail"><div className={`vnode ${v.current ? "cur" : ""}`} /><div className="vline" /></div>
          <div className="vmain">
            <div className="fx ac wrap gap10" style={{ marginBottom: 8 }}>
              <span className="vtag">{v.ver}</span>
              <span className="vdate">{v.date}</span>
              {v.current && <span className="vcurr">Versi saat ini</span>}
              {v.badge && <span className="vbadge">{v.badge}</span>}
            </div>
            {v.feats.map((f, i) => (
              <div className="vfeat fx gap10" key={i}><div className="vfdot" /><div className="vftext">{f}</div></div>
            ))}
          </div>
        </div>
      ))}
    </div>
  </section>
);

export function App() {
  const [platform, setPlatform] = useState<Platform>("ios");
  const [active, setActive] = useState("download");
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const m = window.matchMedia("(max-width: 860px)");
    const on = () => setIsMobile(m.matches);
    on();
    m.addEventListener("change", on);
    return () => m.removeEventListener("change", on);
  }, []);

  useEffect(() => {
    if (isMobile) return; // scrollspy only drives the desktop nav
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && setActive(e.target.id)),
      { rootMargin: "-45% 0px -50% 0px", threshold: 0 },
    );
    NAV.forEach((n) => {
      const el = document.getElementById(n.id);
      if (el) obs.observe(el);
    });
    return () => obs.disconnect();
  }, [isMobile]);

  const go = (id: string) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });

  return (
    <div className="page">
      <div className="blob b1" /><div className="blob b2" />
      <div className="star s1" /><div className="star s2" /><div className="star s3" /><div className="star s4" />

      <header className="topbar fx ac jb gap16">
        <img className="logo" src={logo} alt="BERSIHir" />
        {!isMobile && (
          <>
            <nav className="switcher nav fx ac gap8">
              {NAV.map((n) => (
                <button key={n.id} className={`seg ${active === n.id ? "on" : ""}`} onClick={() => go(n.id)}>{n.label}</button>
              ))}
            </nav>
            <a className="helpx" href="#help">Butuh bantuan?</a>
          </>
        )}
      </header>

      <main className="stage">
        {isMobile ? (
          <>
            {/* MOBILE HERO — centered, no QR */}
            <section id="download" className="mhero col ac gap16">
              <div className="picon fx ac jc"><img src={appIcon} alt="ikon" /></div>
              <div className="col ac gap8">
                <div className="pname">BERSIHir</div>
                <div className="muted fs14 fw7 tc">Bukan sulap, hanya sihir ✨</div>
              </div>
              <div className="fx ac jc wrap gap8">
                <span className="pchip">v0.1.2</span><span className="pchip">Build 599</span><span className="pchip">8.6 MB</span>
              </div>
              <InstallButton />
              <div className="trust fx gap8">
                <span>🔒</span>
                <div><b>iOS:</b> percayai pengembang BERSIHir di Pengaturan › Umum › Manajemen VPN & Perangkat. <b>Android:</b> izinkan pemasangan dari sumber tak dikenal saat diminta.</div>
              </div>
            </section>
            <div className="mstack">
              <HowTo platform={platform} setPlatform={setPlatform} />
              <WhatsNew />
              <Screenshots />
              <Versions />
            </div>
          </>
        ) : (
          <>
            {/* DESKTOP HERO — with QR */}
            <section id="download" className="installcard">
              <div className="col jc gap24">
                <div className="fx ac gap24 wrap">
                  <div className="apptile fx ac jc"><img src={appIcon} alt="ikon" /></div>
                  <div className="col gap8">
                    <div className="appname fred">BERSIHir <span className="verdot">·</span> <span className="blue" style={{ fontSize: 20, fontWeight: 700 }}>v0.1.2</span></div>
                    <div className="tag muted">Bukan sulap hanya sihir ✨</div>
                  </div>
                </div>
                <div className="fx ac wrap gap10">
                  <span className="chip">Versi 0.1.2</span><span className="chip">Build 599</span><span className="chip">8.6 MB</span><span className="chip">iOS · Android</span>
                </div>
                <div className="bundle mono muted">com.bersihir.provider</div>
                <div className="divln" />
                <InstallButton />
                <div className="fx ac gap10 wrap">
                  <button className="ghostbtn fx ac gap8" onClick={() => navigator.clipboard?.writeText(DOWNLOAD_URL)}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><rect x="9" y="9" width="12" height="12" rx="2.5" stroke="currentColor" strokeWidth="2" /><path d="M5 15H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1" stroke="currentColor" strokeWidth="2" /></svg>
                    Salin tautan pasang
                  </button>
                  <button className="ghostbtn" onClick={() => go("howto")}>Lihat cara pasang</button>
                </div>
              </div>
              <div className="qrpanel col ac gap16">
                <div className="cardh fred ink">Pindai untuk memasang</div>
                <div className="muted fs14 tc" style={{ marginTop: -8 }}>Arahkan kamera ponsel ke kode</div>
                <div className="qrbox"><QRCodeSVG value={DOWNLOAD_URL} size={206} level="M" fgColor="#0C3350" /></div>
                <div className="fx ac gap10">
                  <span className="pbadge fx ac gap8"><span className="pbdot" style={{ background: "#0C3350" }} />iOS 14+</span>
                  <span className="pbadge fx ac gap8"><span className="pbdot" style={{ background: "#22C9AB" }} />Android 8+</span>
                </div>
                <div className="expiry fx ac gap8"><span className="pbdot" style={{ background: "#FFB300" }} />Versi terbaru diperbarui · 30 Jun 2026</div>
              </div>
            </section>
            <div className="sections">
              <HowTo platform={platform} setPlatform={setPlatform} />
              <WhatsNew />
            </div>
            <Screenshots />
            <Versions />
          </>
        )}
      </main>

      <footer className="foot fx ac jb wrap gap16">
        <div className="fx ac gap8">Diamankan oleh <b className="blue">BERSIHir</b> · Bukan sulap, hanya sihir</div>
        <div>Build a0ffc50 · com.bersihir.provider · v0.1.2 (599)</div>
      </footer>
    </div>
  );
}
